import { User } from 'generated/graphql';
import PersonAvatar, {
	PersonAvatarSize,
} from 'packages/kakapo-ui-kit/components/users/PersonAvatar';
import { Box, Flex } from 'reflexbox';
import styled from 'styled-components';

const Card = styled(Box)`
	border-radius: 4px;
	padding: 10px;
	background: white;
	box-shadow:
		0px 1px 2px rgba(0, 0, 0, 0.1),
		0px 8px 16px rgba(0, 0, 0, 0.1);
`;

export default function EvaluationAnswerCard({
	children,
	user,
	side,
	withAvatar,
}: {
	children: React.ReactNode;
	side: 'left' | 'right';
	withAvatar: boolean;
	user: User;
}) {
	return (
		<Flex
			flexGrow={1}
			flexDirection={side === 'left' ? 'row' : 'row-reverse'}
			mr={side === 'left' ? 47 : 0}
			ml={side === 'right' ? 47 : 0}
			mt={20}
			style={{ gap: 10 }}
		>
			{withAvatar && (
				<Box flexShrink={0} flexGrow={0}>
					<PersonAvatar size={PersonAvatarSize.Medium} person={user} />
				</Box>
			)}
			<Card flexGrow={1}>{children}</Card>
		</Flex>
	);
}
